// extracted by mini-css-extract-plugin
export default {"borderedBtn":"styles_borderedBtn__L+gVd"};